import SendEmailDialog from './SendEmailDialog.view';

export default SendEmailDialog;
